<autocomplete-list-item (clicked)="triggerEvent()">
  <div class="header">{{ item.name }}</div>
  <div>{{ item.address }}</div>
  <div>{{ item.postalCode }} {{ item.city }}</div>
  <div>{{ item.attribute1 }}</div>
  <div>{{ item.attribute2 }}</div>
</autocomplete-list-item>
